export default "__VITE_ASSET__Crab7WFH__"